var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavTc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.8 28.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.141,10.749h14.158l-2.707,2.706c-.391.39-.391,1.023,0,1.414.195.195.451.293.707.293s.512-.098.707-.293l4.324-4.323c.109-.109.181-.239.229-.376.061-.129.1-.269.1-.421,0-.075-.027-.141-.043-.211.01-.268-.082-.537-.286-.742l-4.324-4.323c-.391-.391-1.023-.391-1.414,0-.391.391-.391,1.023,0,1.414l2.863,2.862H6.141c-.552,0-1,.448-1,1s.448,1,1,1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.659,18.052h-14.158l2.706-2.706c.391-.391.391-1.023,0-1.414-.391-.391-1.023-.391-1.414,0l-4.323,4.323c-.109.109-.18.239-.229.376-.061.129-.1.269-.1.421,0,.075.027.141.043.211-.01.268.082.537.286.742l4.323,4.323c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023,0-1.414l-2.862-2.862h14.314c.553,0,1-.448,1-1s-.447-1-1-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavTc);
export default __webpack_public_path__ + "static/media/Nav-TC.d3dd47784ed3046795c29f9ea19faf13.svg";
export { ForwardRef as ReactComponent };